import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router";
import { ApiClientError } from "../api/client.js";
import {
  PasswordChangedLoginRequiredError,
  useAuth
} from "../auth/AuthProvider.js";

export function ChangePasswordPage() {
  const {
    changePassword,
    continueWithLogin,
    recoverAuthentication
  } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string>();

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (newPassword.length < 12) {
      setError("新密码至少需要 12 个字符。");
      return;
    }
    if (newPassword !== confirmation) {
      setError("两次输入的新密码不一致。");
      return;
    }
    if (newPassword === currentPassword) {
      setError("新密码不能与当前密码相同。");
      return;
    }

    setPending(true);
    setError(undefined);
    try {
      await changePassword(currentPassword, newPassword);
      navigate("/projects", { replace: true });
    } catch (cause) {
      if (recoverAuthentication(cause)) {
        return;
      }
      if (cause instanceof PasswordChangedLoginRequiredError) {
        continueWithLogin("密码已更新，请使用新密码重新登录。");
        navigate("/login", {
          replace: true
        });
        return;
      }
      setError(
        cause instanceof ApiClientError && cause.status === 401
          ? "当前密码不正确。"
          : "密码更新失败，请稍后重试。"
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <main className="foundation-auth-page">
      <section className="foundation-auth-card">
        <p className="foundation-eyebrow">SECURITY CHECKPOINT</p>
        <h1>首次登录，请修改密码</h1>
        <p className="foundation-muted">
          完成修改后会建立全新的安全会话，再进入你的项目。
        </p>
        <form className="foundation-form" onSubmit={submit}>
          <label>
            <span>当前密码</span>
            <input
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              disabled={pending}
            />
          </label>
          <label>
            <span>新密码</span>
            <input
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              disabled={pending}
            />
          </label>
          <label>
            <span>确认新密码</span>
            <input
              type="password"
              autoComplete="new-password"
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
              disabled={pending}
            />
          </label>
          {error ? (
            <p className="foundation-alert foundation-alert--error" role="alert">
              {error}
            </p>
          ) : null}
          <button
            className="foundation-button foundation-button--primary"
            type="submit"
            disabled={pending}
          >
            {pending ? "正在建立新会话…" : "保存新密码"}
          </button>
        </form>
      </section>
    </main>
  );
}
